export interface ResultShareField {
  label: string;
  value: string;
}

export interface ResultShareInput {
  calculatorName: string;
  benderLabel?: string;
  conduitLabel?: string;
  fields: ResultShareField[];
  shareUrl?: string;
}

export function buildResultShareText({
  calculatorName,
  benderLabel,
  conduitLabel,
  fields,
  shareUrl,
}: ResultShareInput): string {
  const lines = [`Truebend - ${calculatorName}`];
  const setup = [conduitLabel, benderLabel].filter(Boolean).join(' / ');
  if (setup) lines.push(setup);
  for (const field of fields) {
    lines.push(`${field.label}: ${field.value}`);
  }
  if (shareUrl) lines.push(`Open in Truebend: ${shareUrl}`);
  return lines.join('\n');
}
